// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VISHAL BHARATHI
// Last ADD : ENACH REPORT EXPORT ACTION REMOVED
// MODIFIED DATE: 19-09-2025

import ENACHReportActionTypes from './enachReport.types';

/** ***************** FETCH ENACH REPORT START *********************** */
export const fetchENACHReportStart = (getData: any) => ({
	type: ENACHReportActionTypes.FETCH_ENACH_REPORT_START,
	payload: getData,
});

export const fetchENACHReportSuccess = (successData: any) => ({
	type: ENACHReportActionTypes.FETCH_ENACH_REPORT_SUCCESS,
	payload: successData,
});

export const fetchENACHReportFailure = (failureData: any) => ({
	type: ENACHReportActionTypes.FETCH_ENACH_REPORT_FAILURE,
	payload: failureData,
});

export const fetchENACHReportResponseReset = () => ({
	type: ENACHReportActionTypes.FETCH_ENACH_REPORT_RESPONSE_RESET,
});

export const fetchENACHReportResponseChanged = () => ({
	type: ENACHReportActionTypes.FETCH_ENACH_REPORT_RESPONSE_CHANGED,
});
/** ***************** FETCH ENACH REPORT END *********************** */
